<template>
  <detail
    :on-manager="onManager"
    :data="resData"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    resource="projectrecords"
    :nameProps="{ edit: false }"
    status-module="reportProject" />

</template>

<script>
import { mapState } from 'vuex'
import { cityMap } from '@/utils/utils'

export default {
  name: 'ProjectDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      cityOps: [],
      addressDesc: '',
      customerInfo: {},
      baseInfo: [
        {
          field: 'enterprise_name',
          title: this.$t('scope.text_870'),
        },
        {
          field: 'amount',
          title: this.$t('scope.text_871'),
        },
        {
          field: 'address',
          title: this.$t('scope.text_872'),
          formatter: ({ cellValue }) => {
            return cityMap(this.cities, cellValue)
          },
        },
        {
          field: 'contact',
          title: this.$t('scope.text_873'),
        },
        {
          field: 'department',
          title: this.$t('scope.text_874'),
        },
        {
          field: 'position',
          title: this.$t('scope.text_875'),
        },
        {
          field: 'created_at',
          title: this.$t('scope.text_876'),
          formatter: ({ row }) => {
            return (row.created_at && this.$moment(row.created_at).format()) || '-'
          },
        },
      ],
      extraInfo: [
        {
          title: this.$t('scope.text_894'),
          items: [
            {
              field: 'customerInfo.enterprise_name',
              title: this.$t('scope.text_895'),
            },
            {
              field: 'customerInfo.email',
              title: this.$t('scope.text_896'),
            },
            {
              field: 'customerInfo.name',
              title: this.$t('scope.text_897'),
            },
            {
              field: 'customerInfo.mobile',
              title: this.$t('scope.text_432'),
            },
          ],
        },
      ],
    }
  },
  computed: {
    ...mapState('app', {
      cities: state => state.cities,
    }),
    resData () {
      return {
        ...this.data,
        customerInfo: this.customerInfo,
      }
    },
  },
  created () {
    this.manager = new this.$Manager('customers')
    this.fetchCustomerInfo()
  },
  destroyed () {
    this.manager = null
  },
  methods: {
    fetchCustomerInfo () {
      this.manager.get({ id: this.data.customer_id }).then(res => {
        this.customerInfo = res.data
      })
    },
  },
}
</script>
